import get from 'lodash/get';

import { Status } from 'redux/models/Design';
import { SPACE_STATUS_STRINGS } from 'utils/constants';

/**
* Method to check if this space fetched from PPO has layouts.
* @return boolean
*/
export function spaceHasLayouts ({ designs = [] }) {
  return designs
    .filter(design => !!get(design, 'layoutInfo', null))
    .length > 0
  ;
}

/**
* Method to get the number of non viewed designs in this space fetched from PPO.
* @return number
*/
export function getNumDesignsNotViewed ({ designs = [] }) {
  return designs
    .reduce((total, design) => {
      if (design.numViewsOwner === 0 && design.status === Status.ACTIVE) {
        total++;
      }
      return total;
    }, 0);
}

/**
* Method to convert the status of this space fetched from PPO into a readable string status.
* @return number
*/
export function getSpaceStatus ({ processed }) {
  return SPACE_STATUS_STRINGS[processed] || '';
}
